define( 'responsive-game-feed/app/scripts/utils/DeviceDetection',[],function(){

	var FORMFACTORS = {
			"OTHER"  : 0,
			"PHONE"  : 1,
			"TABLET" : 2
		},
		PLATFORMS = {
			"OTHER"      : 0,
			"IOS"        : 1,
			"ANDROID"    : 2,
			"BLACKBERRY" : 3,
			"WINMOBILE"  : 4,
			"WINDOWS"    : 5,
			"MAC"        : 6
		},
		BROWSERS = {
			"OTHER"      : 0,
			"WEBKIT"     : 1,
			"CHROME"     : 2,
			"SAFARI"     : 3,
			"IE"         : 4,
			"OPERA"      : 5,
			"OPERAMINI"  : 6,
			"FIREFOX"    : 7
		},
		formFactor = 0,
		platform = 0,
		browser = 0,
		osVersion = 0,
		browserVersion = 0,
		browserName,
		platformName;

	function calculate() {
		calculatePlatform();
		calculateBrowser(platform);
		calculateFormFactor(platform);
		calculateOSVersion(platform, formFactor);
	};

	// alert(navigator.userAgent);

	function calculatePlatform() {
		var platformx =  (/(Android|iPhone|iPad|iPod|BlackBerry|BB10| RIM |Windows Phone|Windows NT|Macintosh)/i.exec(navigator.userAgent));

		if(!platformx || platformx.length<2) {
			platform = PLATFORMS.OTHER;
			return;
		}

		var platformx1 = platformx[1].toLowerCase();


		if(platformx1=="iphone" || platformx1=="ipad"||platformx1=="ipod") {
			platform = PLATFORMS.IOS;
			return;
		}
		else if(platformx1=="blackberry" || platformx1==" rim ") {
			platform = PLATFORMS.BLACKBERRY;
			return;
		}
		else if(platformx1=="bb10") {
			platform = PLATFORMS.BLACKBERRY;
			return;
		}
		else if(platformx1=="windows phone") {
			platform = PLATFORMS.WINMOBILE;
			return;
		}
		else if(platformx1=="android") {
			platform = PLATFORMS.ANDROID;
		}
		else if((platformx1=="macintosh")) {
			platform = PLATFORMS.MAC;
		}
		else if((platformx1=="windows nt")) {
			platform = PLATFORMS.WINDOWS;
		}

	};

	function getBrowserVersion(UA) {
		var version = '',
			i = 0;

		for (; i<UA.length; i++) {

			if(UA[i] !== '.') {
				version += UA[i];
			} else {
				break;
			}
		}
		return version;
	}

	function calculateBrowser(thePlatform) {
		var p = thePlatform,
			UA = navigator.userAgent,
			ISCHROME = UA.match(/chrome/i),
			ISIOSCHROME = UA.match(/crios/i),
			ISFIREFOX = UA.match(/firefox/i),
			ISOPERAMOBILE = UA.match(/opera mobi/i),
			ISOPERAMINI = UA.match(/opera mini/i),
			ISMSIE = UA.match(/msie/i),
			ISIEMOBILE = UA.match(/iemobile/i),
			ISSAFARI = UA.match(/safari/i),
			ISWEBKIT = UA.match(/AppleWebKit/i);

		var userAgent;

		if (p !== 0 || p !== 5 || p !== 6) {
			browserVersion = '';
		}

		if(p==PLATFORMS.ANDROID) {
			if(ISCHROME) {
				browser = BROWSERS.CHROME;
			}
			else if(ISFIREFOX) {
				browser = BROWSERS.FIREFOX;
			}
			else if(ISOPERAMOBILE) {
				browser = BROWSERS.OPERA;
			}
			else if(ISOPERAMINI) {
				browser = BROWSERS.OPERAMINI;
			} else {
				browser = BROWSERS.WEBKIT;
			}
		}
		else if(p==PLATFORMS.IOS) {
			if(ISIOSCHROME) {
				browser = BROWSERS.CHROME;
			}
			else if(ISOPERAMINI) {
				browser = BROWSERS.OPERAMINI;
			}
			else {
				browser = BROWSERS.SAFARI;
			}
		}
		else if(p==PLATFORMS.WINMOBILE) {
			if(ISMSIE) {
				browser = BROWSERS.IE;

				// Latest windows mobile IE versions should provide a version
				if (UA.indexOf('IEMobile')) {
					userAgent = UA.split('MSIE ')[1];
				}
			} else {
				browser = BROWSERS.OTHER;
			}
		}
		else if(p==PLATFORMS.MAC || p==PLATFORMS.WINDOWS) {
			if(ISCHROME) {
				browser = BROWSERS.CHROME;
				userAgent = UA.split('Chrome/')[1];
			}
			else if(ISFIREFOX) {
				browser = BROWSERS.FIREFOX;
				userAgent = UA.split('Firefox/')[1];
			}
			else if(ISSAFARI) {
				browser = BROWSERS.SAFARI;
				userAgent = UA.split('Version/')[1];
			}
			else if(ISMSIE) {
				browser = BROWSERS.IE;
				userAgent = UA.split('MSIE ')[1];
			}
		} else if (p==PLATFORMS.BLACKBERRY){
			if (ISWEBKIT) {
				browser = BROWSERS.WEBKIT;
				userAgent = UA.split('Mobile Safari/')[1];
			}
		} else {
			browser = BROWSERS.OTHER;
		}

		if (userAgent) {
			browserVersion = getBrowserVersion(userAgent);
		}
	}

	function calculateFormFactor(thePlatform) {
		var p = thePlatform;
		if(p==PLATFORMS.ANDROID) {
			//	http://googlewebmastercentral.blogspot.com/2011/03/mo-better-to-also-detect-mobile-user.html
			if(navigator.userAgent.match(/mobile/i)) {
				formFactor = FORMFACTORS.PHONE;
			}
			else {
				formFactor = FORMFACTORS.TABLET;
			}
		}
		else if(p==PLATFORMS.IOS) {
			if(navigator.userAgent.match(/iPad/i)) {
				formFactor = FORMFACTORS.TABLET;
			}
			else {
				formFactor = FORMFACTORS.PHONE;
			}
		}
		else if(p==PLATFORMS.BLACKBERRY) {
			if(navigator.userAgent.match(/Tablet/i)) {
				formFactor = FORMFACTORS.TABLET;
			}
			else {
				formFactor = FORMFACTORS.PHONE;
			}
		}
		else if(p==PLATFORMS.WINMOBILE) {
			formFactor = FORMFACTORS.PHONE;
		}
		else {
			formFactor = FORMFACTORS.OTHER;
		}
	};

	function calculateOSVersion(thePlatform, theFormFactor) {
		if(thePlatform==PLATFORMS.ANDROID) {
			var version = /Android\s+([\d\.]+)/i.exec(navigator.userAgent);
			if(version) {
				osVersion = version[1];
			}
		}
		else if(thePlatform==PLATFORMS.IOS) {
			var version = /OS\s+([\d\_]+)/i.exec(navigator.userAgent);
			if(version) {
				osVersion = version[1].replace(/_/g, ".");
			}
		}
		else if(thePlatform==PLATFORMS.BLACKBERRY) {
			if(theFormFactor==FORMFACTORS.PHONE) {
				var version = /BlackBerry\w+\/([\d\.]+)/i.exec(navigator.userAgent);

				if(version) {
					osVersion = version[1];
				} else {
					// Newer versions use this regex
					osVersion = navigator.userAgent.match(/Version\/(\S{0,4}).*?Safari\//)[1];
				}
			}
			else if(theFormFactor==FORMFACTORS.TABLET) {
				var version = /OS\s+([\d\.]+)/i.exec(navigator.userAgent);
				if(version) {
					osVersion = version[1];
				}
			}
		}
		else if(thePlatform==PLATFORMS.WINMOBILE) {
			var version = /OS\s+([\d\.]+)/i.exec(navigator.userAgent) || /Windows Phone\s+([\d\.]+)/i.exec(navigator.userAgent);
			if(version) {
				osVersion = version[1];
			}
		} else {
			osVersion = '';
		}
	};

	/*-------------------------------------------------
	 @description check an OS Version against
	 the current OS Version from bammobile.device

	 @param {String}
	 @return {Boolean}
	 --------------------------------------------------*/
	function isCurrentOsNewerThan(v2 /*,inclusive*/) {
		/*---------------------------
		 not sure what this does
		 so commenting out
		 ---------------------------*/
		//	inclusive = typeof inclusive !== 'undefined' ? !!inclusive : false;

		var version = v2.toString();
		osSplit = osVersion.toString().split('.'),
			versionSplit = version.split('.'),
			osLen = osSplit.length,
			versionLen = versionSplit.length,
			len = Math.max(osLen, versionLen),
			i = 0;

		for ( ; i < len; i++ ) {
			var osInteger = osSplit[i],
				versionInteger = versionSplit[i];

			if ( versionInteger < osInteger ) {
				return true;
			} else if ( versionInteger > osInteger ) {
				return false;
			}
		}

		if ( versionLen > osLen ) {
			return false;
		}
		/*---------------------------
		 not sure what this does
		 so commenting out
		 ---------------------------*/
		// return inclusive;
	};

	function DeviceDetection(){
		calculate();

		for ( var name in PLATFORMS ) {
			if(platform === PLATFORMS[name]) {
				platformName = name;
				//	console.log(platform, ' : ', name)
			}
		}

		for ( var name in BROWSERS ) {
			if(browser === BROWSERS[name]) {
				browserName = name;
				//	console.log(browser, ' : ', name)
			}
		}

		for ( var name in FORMFACTORS ) {
			if(formFactor === FORMFACTORS[name]) {
				formFactorName = name;
				//	console.log(formFactor, ' : ', name)
			}
		}
		
		window.DeviceType = window.DeviceType || {};
		window.DeviceType.device = window.DeviceType.device || formFactorName.toLowerCase();

		return {
			"userAgent"      : navigator.userAgent,
			"platform" 		 : platform,
			"platformName"   : platformName,
			"browserName"    : browserName,
			"browserVersion" : browserVersion,
			"formFactorName" : formFactorName,
			"osVersion"      : osVersion,
			"isCurrentOsNewerThan"    : isCurrentOsNewerThan
		};
	}
	
	return DeviceDetection;
});

